import { Steps, Tooltip } from 'antd';
import { useStepTracker } from '../contexts/StepTrackerContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

const StepTracker = () => {
  const { currentStep, steps, completedSteps } = useStepTracker();

  const getStepStatus = (step) => {
    if (completedSteps.has(step.id)) return 'finish';
    if (currentStep === step.id) return 'process';
    return 'wait';
  };

  return (
    <div style={{ marginTop: '10px', marginBottom: '30px' }}>
      <Steps
        current={currentStep - 1}
        size="small"
        items={steps.map((step) => ({
          title: (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span>{step.title}</span>
              <Tooltip title={step.description}>
                <FontAwesomeIcon
                  icon={faQuestionCircle}
                  style={{ fontSize: '0.9em', cursor: 'pointer' }}
                />
              </Tooltip>
            </div>
          ),
          status: getStepStatus(step),
        }))}
      />
    </div>
  );
};

export default StepTracker;
